import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

import { SearchableListSizeConfig } from "../../styles";

export const ListOfFolders = styled.ul`
    height: ${SearchableListSizeConfig.height}px;
    margin-top: ${Spacing.MD}px;
    margin-bottom: 0;
    padding: 0 ${Spacing.SM}px;

    list-style-type: none;
`;
